import { ActionReducerMap } from '@ngrx/store';

import { routerReducer } from '@ngrx/router-store';
import { IAppState } from '../state/app.state';
import { menuReducers } from './menu.reducers';
import { nextReducers } from './next.reducers';
import { raceReducers } from './race.reducers';
import { scoReducers } from './sco.reducers';
import { scoSystemReducers } from './scosystem.reducers';
import { InjectionToken } from '@angular/core';
import { identifyReducers } from './identify.reducers';
import { languagesReducers } from './languages.reducers';
import { pageReducers } from './page.reducers';
import { channelsReducers } from './channels.reducers';
import { balanceReducers } from './balance.reducers';
import { receResultReducers } from './receresult.reducers';
import { betMultipleReducers } from './betmultiple.reducers';
import { messageReducers } from './message.reducers';
import { totSelectReducers } from './totselect.reducers';
import { totraceReducers } from './totrace.reducers';
import {eventReducers} from './event.reducers';

export const appReducers: ActionReducerMap<IAppState, any> = {
  router: routerReducer,
  menu: menuReducers,
  next: nextReducers,
  race: raceReducers,
  sco: scoReducers,
  scosystem: scoSystemReducers,
  identify: identifyReducers,
  languages: languagesReducers,
  page: pageReducers,
  channels: channelsReducers,
  balance: balanceReducers,
  raceResult: receResultReducers,
  betmultiple: betMultipleReducers,
  message: messageReducers,
  totselect: totSelectReducers,
  totrace: totraceReducers,
  event: eventReducers
};

export const REDUCERS_TOKEN = new InjectionToken<ActionReducerMap<IAppState, any>>('App Reducers');
